'use client'

import { useState } from 'react'
import type { PropsWithChildren } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

// Create a singleton queryClient for use outside React components
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      retry: 1,
      staleTime: 0, // Data becomes stale immediately
    },
  },
})

export function ReactQueryProvider({ children }: PropsWithChildren) {
  const [client] = useState(() => queryClient)

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>
}

export default ReactQueryProvider
